import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCraftcmsComponent } from './simple-icons-craftcms.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCraftcmsComponent ],
    exports:      [ SimpleIconsCraftcmsComponent ],
    bootstrap:    []
})
export class SimpleIconsCraftcmsModule {}
